export default __webpack_public_path__ + "images/IC.94afaf5.png";